export const getSessionStorage = (key: string): string | null => {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(key);
};

export const setSessionStorage = (key: string, value: string): void => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(key, value);
};
